import { upperFirst } from 'lodash/fp'
import React from 'react'

import { ClipboardText } from 'packages/common'
import { Amenities } from 'packages/grimoire'
import { useI18n } from 'packages/i18n'
import { IconName } from 'packages/iconic'

import {
  InfoRowLabel,
  Details,
  DetailIcon,
  SectionSubTitle,
  UnitInfoContainer,
} from 'app/fieldapp/components/schedule/components/TaskSharedStyles'
import { Slugs } from 'app/fieldapp/i18n'

const St = {
  DetailIcon,
  Details,
  InfoRowLabel,
  SectionSubTitle,
  UnitInfoContainer,
}

export type VisitWifiInfoProps = {
  amenities: Amenities
}

export const VisitWifiInfo: React.FC<VisitWifiInfoProps> = React.memo(
  ({ amenities }) => {
    const { t } = useI18n()

    return amenities.wifi ? (
      <St.UnitInfoContainer>
        <St.DetailIcon icon={IconName.wifi} size={16} />
        <St.Details>
          <St.SectionSubTitle>{t(Slugs.wifi)}</St.SectionSubTitle>

          <div>
            <St.InfoRowLabel>
              {`${upperFirst(t(Slugs.network))}: `}
            </St.InfoRowLabel>

            {amenities.wifiNetwork}
          </div>

          <div>
            <St.InfoRowLabel>
              {`${upperFirst(t(Slugs.password))}:`}
            </St.InfoRowLabel>

            {amenities.wifiPassword && (
              <ClipboardText>{amenities.wifiPassword}</ClipboardText>
            )}
          </div>
        </St.Details>
      </St.UnitInfoContainer>
    ) : null
  },
)
